module.exports = fox._r("images/reg_bg_urban.png", __webpack_public_path__ + "images/reg_bg_urban.png");


//////////////////
// WEBPACK FOOTER
// ./images/reg_bg_urban.png
// module id = 523
// module chunks = 2